import { apiRequest, readJsonOrThrow } from "@/api/client";

const REFERRAL_COOKIE_NAME = "clipr_ref";
const SESSION_COOKIE_NAME = "clipr_affiliate_session";
const MAX_AGE_SECONDS = 90 * 24 * 60 * 60;
const CODE_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

function isCliprDomain(hostname) {
  const normalized = String(hostname || "").toLowerCase();
  return normalized === "clipr.tv" || normalized.endsWith(".clipr.tv");
}

function cookieAttributes() {
  const attributes = [
    "Path=/",
    `Max-Age=${MAX_AGE_SECONDS}`,
    "SameSite=Lax",
  ];
  if (window.location.protocol === "https:") attributes.push("Secure");
  if (isCliprDomain(window.location.hostname)) attributes.push("Domain=.clipr.tv");
  return attributes.join("; ");
}

function readCookie(name) {
  const prefix = `${name}=`;
  for (const rawCookie of String(document.cookie || "").split(";")) {
    const cookie = rawCookie.trim();
    if (cookie.startsWith(prefix)) {
      return decodeURIComponent(cookie.slice(prefix.length));
    }
  }
  return "";
}

function writeCookie(name, value) {
  document.cookie = `${name}=${encodeURIComponent(value)}; ${cookieAttributes()}`;
}

export function readAffiliateReferralCode() {
  const raw = readCookie(REFERRAL_COOKIE_NAME);
  if (!raw) return "";
  const referral = JSON.parse(raw);
  return String(referral.code || "").trim().toLowerCase();
}

function getAffiliateSessionId() {
  const existing = readCookie(SESSION_COOKIE_NAME);
  if (existing) return existing;
  const sessionId = crypto.randomUUID();
  writeCookie(SESSION_COOKIE_NAME, sessionId);
  return sessionId;
}

export async function captureAffiliateAttribution() {
  const code = String(
    new URLSearchParams(window.location.search).get("ref") || ""
  ).trim().toLowerCase();
  if (!code) return;
  if (!CODE_PATTERN.test(code) || code.length > 64) {
    throw new Error("Invalid Clipr affiliate code format.");
  }

  writeCookie(
    REFERRAL_COOKIE_NAME,
    JSON.stringify({ code, timestamp: Date.now() })
  );

  const response = await apiRequest("/momo/affiliates/click", {
    method: "POST",
    body: {
      code,
      path: window.location.pathname,
      session_id: getAffiliateSessionId(),
    },
  });
  await readJsonOrThrow(response, "Failed to record affiliate click");
}
